import {
  // Auth
  auth,
  // Firestore
  firestore,
  collection,
  getDocs,
  documentId,
  query,
  where,
} from "@/firebase/init";
import moment from "moment";

const state = {
  appName: "MyTrace",
  phases: [
    {
      text: "company mgmt",
      value: "companymgmt",
      icon: "mdi-card-account-details",
      desc: "-",
      vendorDesc: "",
      users: ["admin"],
      sort: 0,
      phase: 0,
      vendorLogin: false,
    },
    {
      text: "sourcing",
      value: "sourcing",
      icon: "mdi-source-fork",
      desc: "Define brands/products & warehouse locations. Create Vendor Orders for product components to be manufactured in Work Orders",
      vendorDesc: "",
      users: ["admin", "fulfillment", "accounting"],
      sort: 1,
      phase: 1,
      vendorLogin: false,
    },
    {
      text: "manufacturing",
      value: "manufacturing",
      icon: "mdi-hammer-wrench",
      desc: "Define raw materials/mixing formulas & schedule Work Orders for manufacturing runs",
      vendorDesc: "",
      users: ["admin", "manufacturing", "accounting"],
      sort: 2,
      phase: 2,
      vendorLogin: false,
    },
    {
      text: "sales",
      value: "sales",
      icon: "mdi-cash-multiple",
      desc: "Manage leads/accounts, complete account onboardings and create/fulfill sales orders",
      vendorDesc: "",
      users: ["admin", "sales", "fulfillment", "accounting"],
      sort: 3,
      phase: 3,
      vendorLogin: false,
    },
    {
      text: "retail success",
      value: "events",
      icon: "mdi-face-agent",
      desc: "Grow relationships with accounts through store promotions & complete exchanges with stores/customers",
      vendorDesc:
        "Create a login for a brand ambassador from a event staffing company.",
      users: ["admin", "sales", "support"],
      sort: 4,
      phase: 4,
      vendorLogin: true,
    },
    {
      text: "admin",
      value: "admin",
      icon: "mdi-shield-account",
      desc: "General system usage, Project & Data Management",
      vendorDesc: "",
      users: ["admin"],
      sort: 5,
      phase: 5,
      vendorLogin: false,
    },
    // {
    //   text: "trace reports",
    //   value: "reports",
    //   icon: "mdi-file-chart",
    //   sort: 6,
    //   phase: 6,
    //   desc: "View tailored 'Trace' reports using data points from the modules above (Inventory runway/Sales performance/Store promotion results...)",
    //   vendorLogin: false,
    //   route: "/reporting/overview",
    //   routeText: "Reports",
    //   routeValue: "reports-overview",
    //   views: [
    //     "reports-overview",
    //     "admin-tasks-report",
    //     "admin-projects-report",
    //     "admin-repProductivity-report",
    //     "admin-notifications-report",
    //     "admin-futures-report",
    //     "admin-sales-report",
    //     "admin-marketingExpenses-report",
    //     "sourcing-vendors-report",
    //     "sourcing-customProductCategories-report",
    //     "sourcing-orders-report",
    //     "sourcing-deposits-report",
    //     "sourcing-shipments-report",
    //     "sourcing-shipEngine-report",
    //     "manufacturing-workOrders-report",
    //     "manufacturing-inventory-report",
    //     "manufacturing-rawMaterialOrders-report",
    //     "manufacturing-productLots-report",
    //     "sales-leaderboard-report",
    //     "sales-score-report",
    //     "sales-accounts-report",
    //     "sales-map-report",
    //     "sales-accountMetrics-report",
    //     "sales-accountPricing-report",
    //     "sales-closes-report",
    //     "sales-onboardings-report",
    //     "sales-actionLists-report",
    //     "sales-tasks-report",
    //     "sales-brandmtd-report",
    //     "sales-orders-report",
    //     "sales-ordersByAccount-report",
    //     "sales-traceOrders-report",
    //     "sales-historicalStats-report",
    //     "sales-productCategories-report",
    //     "sales-postDiscount-report",
    //     "sales-products-report",
    //     "sales-topProducts-report",
    //     "sales-deliveryLogistics-report",
    //     "sales-ar-report",
    //     "sales-payments-report",
    //     "sales-bonus-report",
    //     "sales-credits-report",
    //     "sales-creditsVsSales-report",
    //     "sales-tpva-report",
    //     "support-storeEvents-report",
    //     "support-trainings-report",
    //     "support-supportTickets-report",
    //     "support-deliveryCogs-report",
    //     "leaflink-salesDashboard-report",
    //     "nabis-accounts-report",
    //     "nabis-inventory-report",
    //     "nabis-orders-report",
    //     // "manufacturing-leaflink-inventory-report",
    //     // "leaflink-orders-report",
    //     // "leaflink-reservedInventory-report",
    //   ],
    // },
  ],
  phaseViews: [
    // Company MGMT
    {
      text: "brands",
      value: "brandsOverview",
      desc: "Brands are used in Purchase and Sales orders. Note that the permissions set here also apply to licensee pages.",
      views: [
        "brands-overview",
        "brand-new",
        "brand-view",
        "payableTo-new",
        "payableTo-view",
        "priceOverride-view",
      ],
      icon: "mdi-store",
      sort: 1,
      phase: 0,
      route: "/brands/overview",
    },
    {
      text: "products",
      value: "products",
      desc: "View a list of product categories/products for brands",
      views: [
        "products-overview",
        "category-new",
        "category-view",
        "products-new",
        "products-view",
      ],
      icon: "mdi-sitemap",
      sort: 2,
      phase: 0,
      route: "/products/overview/",
    },
    {
      text: "product recipes",
      value: "productRecipes",
      desc: "Define product 'recipes' to calculate the needed raw materials/terpenes during a work order based on the QTY being manufactured",
      views: ["productRecipes-overview", "productRecipes-edit"],
      icon: "mdi-tune-vertical",
      sort: 3,
      phase: 0,
      route: "/productRecipes/overview",
    },
    {
      text: "testing labs",
      value: "testingLabs",
      desc: "Testing labs are used within a work order during the 'testing' steps",
      views: ["testingLabs-overview", "testingLabs-new", "testingLabs-view"],
      icon: "mdi-test-tube",
      sort: 4,
      phase: 0,
      route: "/testingLabs/overview",
    },
    {
      text: "raw materials",
      value: "rawMaterials",
      desc: "Raw material batches can be purchased with a 'Raw material order' & managed in a location during a work order",
      views: [
        "rawMaterials-overview",
        "rawMaterials-new",
        "rawMaterials-view",
        "rawMaterialCategory-new",
        "rawMaterialCategory-view",
      ],
      icon: "mdi-cannabis",
      sort: 5,
      phase: 0,
      route: "/rawMaterials/overview",
    },
    {
      text: "delivery/logistics",
      value: "deliveryLogistics",
      desc: "Define delivery companies & set their schedule based on day/counties (Delivers to X county on Y day)",
      views: [
        "deliveryLogistics-overview",
        "deliveryLogistic-new",
        "deliveryLogistic-view",
      ],
      icon: "mdi-truck",
      sort: 6,
      phase: 0,
      route: "/deliveryLogistics/overview",
    },
    // {
    //   text: "projects",
    //   value: "projects",
    //   desc: "Tasks can be defined & assigned to users. A project cannot be completed until all related tasks are complete",
    //   views: ["projects-overview", "projects-new", "projects-view"],
    //   icon: "mdi-chart-gantt",
    //   sort: 8,
    //   phase: 0,
    //   route: "/projects/overview",
    // },
    {
      text: "QR codes",
      value: "qrCodes",
      desc: "Create a dynamic QR Code based on a QR code templaate",
      views: ["qrCodes", "qrCodes-new", "qrCodes-view"],
      icon: "mdi-qrcode-scan",
      sort: 9,
      phase: 0,
      route: "/qrCodes/overview",
    },
    // {
    //   text: "email templates",
    //   value: "emailTemplates-overview",
    //   views: [
    //     "emailTemplates-overview",
    //     "emailTemplate-new",
    //     "emailTemplate-view",
    //   ],
    //   icon: "mdi-email-newsletter",
    //   sort: 9,
    //   phase: 0,
    //   route: "/emailTemplates/overview",
    // },
    // {
    //   text: "emails",
    //   value: "emails",
    //   views: ["emails"],
    //   icon: "mdi-email-multiple",
    //   sort: 10,
    //   phase: 0,
    //   route: "/emails/overview",
    // },
    // Sourcing
    {
      text: "vendors",
      value: "vendors",
      desc: "Define a list of vendors for use with Vendor/Custom Orders",
      views: ["vendors-overview", "vendors-new", "vendors-view"],
      icon: "mdi-folder-account",
      sort: 0,
      phase: 1,
      route: "/vendors/overview",
    },
    {
      text: "raw material vendors",
      value: "rawMaterialVendors",
      desc: "A Raw material vendor supplies 'raw materials' for use within a raw material order. A menu of what they offer can be defined",
      views: [
        "rawMaterialVendors-overview",
        "rawMaterialVendors-new",
        "rawMaterialVendors-view",
      ],
      icon: "mdi-power-plug",
      sort: 1,
      phase: 1,
      route: "/rawMaterialVendors/overview",
    },
    // {
    //   text: "white label brands",
    //   value: "whiteLabelBrands",
    //   desc: "White label brands are 3rd parties you manufacture for. The 'testing' steps are skipped on white label work orders",
    //   views: [
    //     "whiteLabelBrands-overview",
    //     "whiteLabelBrand-new",
    //     "whiteLabelBrand-view",
    //   ],
    //   icon: "mdi-package-variant",
    //   sort: 3,
    //   phase: 1,
    //   route: "/whiteLabelBrands/overview",
    // },
    // {
    //   text: "white label products",
    //   value: "whiteLabelProducts",
    //   desc: "View a list of products that are filtered specifically to white label brands",
    //   views: [
    //     "whiteLabelProducts-overview",
    //     "category-new",
    //     "category-view",
    //     "products-new",
    //     "products-view",
    //   ],
    //   icon: "mdi-sitemap",
    //   sort: 4,
    //   phase: 1,
    //   route: "/whiteLabelProducts/overview/",
    // },
    {
      text: "component orders",
      value: "vendorOrders",
      desc: "The products on a vendor order will be added as 'incoming' inventory to a location. Vendor orders can only be created with 'Retail' brands",
      views: [
        "vendorOrders-overview",
        "vendorOrder-brand-new",
        "vendorOrder-products-new",
        "vendorOrder-review-new",
        "vendorOrder-master-view",
        "vendorOrder-productCategory-view",
        "vendorOrder-invoice-view",
      ],
      icon: "mdi-truck",
      sort: 2,
      phase: 1,
      route: "/vendorOrders/overview",
    },
    {
      text: "raw material orders",
      value: "rawMaterialOrders",
      desc: "The raw material batches purchased from these orders are added to the location inventory. The related work orders that use the raw materials from these orders will be linked",
      views: [
        "rawMaterialOrders-overview",
        "rawMaterialOrder-new",
        "rawMaterialOrders-view",
      ],
      icon: "mdi-clipboard-list",
      sort: 3,
      phase: 1,
      route: "/rawMaterialOrders/overview",
    },
    {
      text: "locations",
      value: "locations",
      desc: "Define warehouses within a state for inventory management & manufacture products with 'Work Orders'",
      views: [
        "locations-overview",
        "locations-new",
        "locations-view",
        "location-rawMaterials-overview",
        "location-componentBatches-overview",
        "componentBatch-view",
        "location-productLots-overview",
        "inventory-reconcile-overview",
        "transfer-inventory-overview",
        "new-transfer-location-select",
        "transfer-assembled-new",
        "transfer-assembled-view",
        "transfer-components-new",
        "transfer-components-view",
        "transfer-rawMaterials-new",
        "transfer-rawMaterials-view",
        "manufacturing-overview",
        "workOrder-brand-new",
        "new-workOrder-products",
        "new-workOrder-review",
        "mainWorkOrder-view",
        "productWorkOrder-view",
        "location-white-label-orders-overview",
        "whiteLabelOrder-new-select",
        "whiteLabelOrder-new-review",
        "whiteLabelInvoice-view",
      ],
      icon: "mdi-warehouse",
      sort: 4,
      phase: 1,
      route: "/locations/overview",
    },
    // {
    //   text: "vendor orders",
    //   value: "vendorOrders",
    //   desc: "The products on a vendor order will be added as 'incoming' inventory to a location. Vendor orders can only be created with 'Retail' brands",
    //   views: [
    //     "vendorOrders-overview",
    //     "vendorOrder-brand-new",
    //     "vendorOrder-products-new",
    //     "vendorOrder-review-new",
    //     "vendorOrder-master-view",
    //     "vendorOrder-productCategory-view",
    //     "vendorOrder-invoice-view",
    //   ],
    //   icon: "mdi-truck",
    //   sort: 6,
    //   phase: 1,
    //   route: "/vendorOrders/overview",
    // },
    // {
    //   text: "custom products",
    //   value: "customProducts",
    //   desc: "Define a list of product categories/products used with Custom orders",
    //   views: [
    //     "customProducts-overview",
    //     "customProductType-new",
    //     "customProductCategory-new",
    //     "customProductCategory-view",
    //     "customProducts-new",
    //     "customProducts-view",
    //   ],
    //   icon: "mdi-sitemap",
    //   sort: 7,
    //   phase: 1,
    //   route: "/customProducts/overview",
    // },
    // {
    //   text: "custom orders",
    //   value: "customOrders",
    //   desc: "Custom orders are meant for purchases that do not need their inventory tracked (5K business cards were purchased from X vendor)",
    //   views: ["customOrders-overview", "customOrder-new", "customOrder-view"],
    //   icon: "mdi-clipboard-list",
    //   sort: 8,
    //   phase: 1,
    //   route: "/customOrders/overview",
    // },
    // Manufacturing
    // {
    //   text: "component batches",
    //   value: "componentBatches",
    //   desc: "",
    //   views: ["componentBatches-overview"],
    //   icon: "mdi-video-input-component",
    //   sort: 0,
    //   phase: 2,
    //   route: "/componentBatches/overview",
    // },
    {
      text: "work orders",
      value: "workOrders",
      desc: "",
      views: ["workOrders-overview"],
      icon: "mdi-beaker",
      sort: 1,
      phase: 2,
      route: "/workOrders/overview",
    },
    {
      text: "product lots",
      value: "productLots",
      desc: "Product Lots are added after testing is completed during a work order. Product Lots will be shown within a sales order based on the line items",
      views: ["productLots-overview", "productLot-new", "productLot-view"],
      icon: "mdi-tag-text",
      sort: 1,
      phase: 2,
      route: "/productLots/overview",
    },
    // Sales
    {
      text: "sales contacts",
      value: "salesContacts",
      desc: "View a rolodex of contacts from the 'Sales' module, filtered by title",
      views: ["salesContacts-overview"],
      icon: "mdi-contacts",
      sort: 0,
      phase: 3,
      route: "/sales/contacts/overview",
    },
    {
      text: "parent accounts",
      value: "parentAccounts",
      desc: "A 'parent' account is used to group a list of all related accounts",
      views: [
        "parentAccounts-overview",
        "parentAccounts-new",
        "parentAccounts-view",
      ],
      icon: "mdi-domain",
      sort: 2,
      phase: 3,
      route: "/parentAccounts/overview",
    },
    {
      text: "accounts",
      value: "accounts",
      desc: "A list of accounts (Storefront/Delivery/Distro/Smoke shop) in your mytrace instance. Individual accounts can be searched for with the 'Search Accounts' field",
      views: ["accounts-overview", "accounts-new", "accounts-view"],
      icon: "mdi-folder-account",
      sort: 3,
      phase: 3,
      route: "/accounts/overview",
    },
    // {
    //   text: "schedules",
    //   value: "sales-schedules",
    //   desc: "-",
    //   views: ["salesSchedule-overview"],
    //   icon: "mdi-invoice-list",
    //   sort: 5,
    //   phase: 3,
    //   route: "/salesSchedule/overview",
    // },
    {
      text: "account onboarding",
      value: "account-onboarding",
      desc: "When an account becomes 'active', an onboarding with tasks to schedule training/staff samples/a store event/intro email ",
      views: [
        "accountOnboardings-overview",
        "accountOnboardings-new",
        "accountOnboardings-view",
      ],
      icon: "mdi-timeline-check",
      sort: 6,
      phase: 3,
      route: "/accountOnboarding/overview",
    },
    {
      text: "draft orders",
      value: "draftOrders",
      desc: "Draft orders are sales orders that have not been submitted & no inventory is reserved yet. Draft orders can also be utilized for backorders",
      views: ["draftOrders-overview"],
      icon: "mdi-clipboard-text",
      sort: 8,
      phase: 3,
      route: "/draftOrders/overview",
    },
    {
      text: "in progress orders",
      value: "salesOrders",
      desc: "All active, in-process orders. When an order is delivered, it will be within 'Delivered' orders view",
      views: ["saleOrders-overview", "salesOrder-new", "salesOrder-view"],
      icon: "mdi-clipboard-list",
      sort: 9,
      phase: 3,
      route: "/salesOrders/overview",
    },
    // {
    //   text: "delivery routes",
    //   value: "orderRoutes",
    //   desc: "Create an optimized delivery route for in-progress orders based on their ship date",
    //   views: ["orderRoutes-overview", "orderRoute-new", "orderRoute-view"],
    //   icon: "mdi-map-marker-distance",
    //   sort: 11,
    //   phase: 3,
    //   route: "/orderRoutes/overview",
    // },
    {
      text: "open balances",
      value: "deliveredOrders",
      desc: "A list of all delivered orders with an open balance. A breakdown of these balances can be seen between COD/Net orders",
      views: ["deliveredOrders-overview"],
      icon: "mdi-cash-marker",
      sort: 12,
      phase: 3,
      route: "/deliveredOrders/overview",
    },
    {
      text: "payments",
      value: "payments",
      desc: "View accounts with outstanding balances and their related sales orders to track payment status",
      views: ["payments-overview"],
      icon: "mdi-cash-multiple",
      sort: 14,
      phase: 3,
      route: "/payments/overview",
    },
    {
      text: "licensee sales",
      value: "licenseeSales",
      desc: "Submit sales/units sold for 3rd party companies that may license your brand, even if they don't use mytrace",
      views: [
        "licenseeSales-overview",
        "licenseeSales-new",
        "licenseeSales-view",
      ],
      icon: "mdi-calendar-check",
      sort: 13,
      phase: 3,
      route: "/licenseeSales/overview",
    },
    {
      text: "menus",
      value: "specials",
      desc: "Define a menu for a retail brand. Can be used as an online menu or for an in-person event.",
      views: ["specials-overview", "specials-new", "specials-view"],
      icon: "mdi-order-bool-descending-variant",
      sort: 7,
      phase: 3,
      route: "/specials/overview",
    },

    // Support
    {
      text: "support contacts",
      value: "supportContacts",
      desc: "A list of contacts from the 'Support' module. These contacts are mainly from the 'Support Tickets' view",
      views: ["supportContacts-overview"],
      icon: "mdi-contacts",
      sort: 0,
      phase: 4,
      route: "/support/contacts/overview",
    },
    {
      text: "promotions",
      value: "promotions-overview",
      desc: "Define a list of promotions for use within 'Store Events'. The Related product categories of this promo can also be set",
      views: ["promotions-overview", "promotions-new", "promotions-view"],
      icon: "mdi-sale",
      sort: 1,
      phase: 4,
      route: "/promotions/overview",
    },
    {
      text: "store events",
      value: "events-overview",
      desc: "Store Events are used to track promotions within a store. (Can be set as in-person or a ghost promo)",
      views: ["storeEvents-overview", "storeEvents-new", "storeEvents-view"],
      icon: "mdi-calendar",
      sort: 3,
      phase: 4,
      route: "/storeEvents/overview",
    },
    {
      text: "trainings",
      value: "budtender-training",
      desc: "A training is used to educate the staff of an account about the brand. Training types can be defined as in person/remote, 1:1/team, etc..",
      views: [
        "budtenderTrainings-overview",
        "budtenderTrainings-new",
        "budtenderTrainings-view",
      ],
      icon: "mdi-school",
      sort: 4,
      phase: 4,
      route: "/trainings/overview",
    },
    {
      text: "support tickets",
      value: "supportTickets-overview",
      desc: "Support tickets are used for managing exchanges with a customer or store",
      views: [
        "supportTickets-overview",
        "supportTickets-new",
        "supportTickets-view",
      ],
      icon: "mdi-briefcase",
      sort: 5,
      phase: 4,
      route: "/supportTickets/overview",
    },
    // Admin
    {
      text: "operating zones",
      value: "operatingZones",
      desc: "Toggle states in your mytrace instance. (Active in AZ/CA/NY...)",
      views: [
        "operatingZones-overview",
        "country-new",
        "country-view",
        "state-new",
        "state-view",
        "territory-new",
        "territory-view",
      ],
      icon: "mdi-earth",
      sort: 0,
      phase: 5,
      route: "/operatingZones/overview",
    },
    {
      text: "users",
      value: "users",
      desc: "Define users & their views/permissions in mytrace. Individual views/report visibility can be set on a per user basis",
      views: ["users", "user-new", "user-view"],
      icon: "mdi-account-group",
      sort: 1,
      phase: 5,
      route: "/users/overview",
    },
    {
      text: "data management",
      value: "dataManager",
      desc: "Import/Export data for your mytrace instance (import a list of accounts from a spreadsheet for use in the 'Accounts' view)",
      views: [
        "dataManagement-overview",
        "dataManagement-mytrace-instance",
        "dataManagement-mytrace-import",
        "dataManagement-mytrace-account",
        "dataManagement-mytrace-account-transfer",
        "dataManagement-mytrace-account-export",
        "dataManagement-mytrace-lineitems-export",
        "dataManagement-mytrace-inventory-export",
        "dataManagement-mytrace-facilities-export",
        "dataManagement-mytrace-brandStats",
        "dataManagement-mytrace-retag",
        "dataManagement-mytrace-recalculate",
        "dataManagement-mytrace-socials",
        "dataManagement-apextrading-accounts",
        "dataManagement-apextrading-products",
        "dataManagement-apextrading-salesOrders",
        "dataManagement-file-excel",
        "dataManagement-mytrace-aggregate-sales",
        "dataManagement-leaflink-sync",
        "dataManagement-leaflink-productLines",
        "dataManagement-leaflink-products",
        "dataManagement-leaflink-accounts",
        "dataManagement-leaflink-contacts",
        "dataManagement-leaflink-salesOrders",
        "dataManagement-distru-import",
        "dataManagement-distru-syncProducts",
        "dataManagement-distru-addProducts",
        "dataManagement-distru-accounts",
        "dataManagement-distru-contacts",
        "dataManagement-distru-salesOrders",
        "dataManagement-nabis-import",
        "dataManagement-nabis-accounts",
        "dataManagement-nabis-products",
        "dataManagement-nabis-salesOrders",
        "dataManagement-quickbooks-config",
        "dataManagement-quickbooks-products",
        "dataManagement-zoho-accounts",
        "dataManagement-zoho-contacts",
        "dataManagement-flourish-accounts",
        "dataManagement-flourish-products",
        "dataManagement-flourish-orders",
        "dataManagement-metrc-accounts",
        "dataManagement-metrc-items",
        "dataManagement-metrc-inventory",
        "dataManagement-metrc-rawMaterials",
        "dataManagement-metrc-salesOrders",
        "dataManagement-hoodie-accounts",
        "dataManagement-hoodie-products",
        "dataManagement-hoodie-menus",
        "dataManagement-ezo-vendors",
        "dataManagement-ezo-locations",
        "dataManagement-ezo-categories",
        "dataManagement-ezo-products",
        "dataManagement-treesnclouds-retailers",
        "dataManagement-method-users",
        "dataManagement-method-customers",
        "dataManagement-method-tasks",
        "dataManagement-method-items",
        "dataManagement-method-invoices",
        "dataManagement-intacct-productLines",
        "dataManagement-intacct-syncAccounts",
        "dataManagement-intacct-products",
        "dataManagement-monday-config",
        "dataManagement-monday-accounts",
        "dataManagement-monday-contacts",
        "dataManagement-hubspot-companies",
        "dataManagement-hubspot-contacts",
      ],
      icon: "mdi-database-sync",
      sort: 1,
      phase: 5,
      route: "/dataManagement/overview",
    },
    {
      text: "integrations",
      value: "integrations",
      desc: "Toggle integrations to extend the functionality of your mytrace instance",
      views: ["integrations-overview"],
      icon: "mdi-dip-switch",
      sort: 2,
      phase: 5,
      route: "/integrations/overview",
    },
    // {
    //   text: "menus",
    //   value: "menus",
    //   desc: "-",
    //   views: [
    //     "menus",
    //     "menus-new",
    //     "menus-view",
    //   ],
    //   icon: "mdi-order-alphabetical-ascending",
    //   sort: 3,
    //   phase: 5,
    //   route: "/menus/overview",
    // },
    // {
    //   text: "project templates",
    //   value: "projectTemplates",
    //   desc: "Set a pre-defined set of tasks for use within a project (Every product launch has Task A/B/C...)",
    //   views: [
    //     "projectTemplates",
    //     "projectTemplates-new",
    //     "projectTemplates-view",
    //   ],
    //   icon: "mdi-format-list-group-plus",
    //   sort: 4,
    //   phase: 5,
    //   route: "/projectTemplates/overview",
    // },
    {
      text: "tasks",
      value: "tasks",
      desc: "Personalized task manager for the current user. Tasks related to a specific account should be created within the 'Account' profile",
      views: ["tasks", "task-new", "task-view"],
      icon: "mdi-file-tree",
      sort: 5,
      phase: 5,
      route: "/tasks/overview",
    },
    {
      text: "white label clients",
      value: "whiteLabelClients",
      desc: "Define a list of white label clients when creating invoices for white label orders",
      views: [
        "whiteLabelClients-overview",
        "whiteLabelClients-new",
        "whiteLabelClients-view",
      ],
      icon: "mdi-package",
      sort: 6,
      phase: 5,
      route: "/whiteLabelClients/overview",
    },
    {
      text: "multi-brand menus",
      value: "menus",
      desc: "Define a menu for a retail brand. Can be used as an online menu or for an in-person event.",
      views: ["menus-overview", "menus-new", "menu-view"],
      icon: "mdi-map-legend",
      sort: 7,
      phase: 5,
      route: "/menus/overview",
    },
  ],
  reports: [
    {
      text: "tasks",
      to: "admin-tasks-report",
      desc: "View pending/complete tasks, filter by state & department",
      icon: "mdi-file-tree",
      type: "admin",
    },
    // {
    // 	text: "projects",
    // 	to: "admin-projects-report",
    // 	desc: "View status of project(s) by selected date range",
    // 	icon: "mdi-chart-gantt",
    // 	type: "admin",
    // },
    // {
    // 	text: "rep productivity",
    // 	to: "admin-repProductivity-report",
    // 	desc: "View tasks/closes & orders across all reps for specified date range",
    // 	icon: "mdi-account-group",
    // 	type: "admin",
    // },
    {
      text: "notifications",
      to: "admin-notifications-report",
      desc: "View all notifications sent in mytrace based on a selected date range & filter read vs. unread",
      icon: "mdi-bell",
      type: "admin",
    },
    // {
    // 	text: "futures",
    // 	to: "admin-futures-report",
    // 	desc: "Upcoming cash flow needed based on pending vendor/custom/raw material order(s)",
    // 	icon: "mdi-timeline-clock",
    // 	type: "admin",
    // },
    {
      text: "sales",
      to: "admin-sales-report",
      desc: "Sales per country",
      icon: "mdi-clipboard-list",
      type: "admin",
    },

    {
      text: "component orders",
      to: "sourcing-componentOrders-report",
      desc: "-",
      icon: "mdi-clipboard-list",
      type: "sourcing",
    },
    {
      text: "raw material orders",
      to: "manufacturing-rawMaterialOrders-report",
      desc: "View raw materials purchased, grouped by raw material type(s) & vendor",
      icon: "mdi-clipboard-list",
      type: "sourcing",
    },
    // {
    //   text: "vendors",
    //   to: "sourcing-vendors-report",
    //   desc: "Vendor/Custom order(s) filtered by selected vendor",
    //   icon: "mdi-folder-account",
    //   type: "sourcing",
    // },
    // {
    //   text: "custom product category orders",
    //   to: "sourcing-customProductCategories-report",
    //   desc: "View custom orders filtered by selected custom product category",
    //   icon: "mdi-sitemap",
    //   type: "sourcing",
    // },
    // {
    //   text: "vendor/custom orders",
    //   to: "sourcing-orders-report",
    //   desc: "Pending/Complete Vendor/Custom orders within selected date range",
    //   icon: "mdi-truck",
    //   type: "sourcing",
    // },
    // {
    //   text: "tracking numbers & shipments",
    //   to: "sourcing-shipments-report",
    //   desc: "View & update tracking numbers for Vendor/Custom orders",
    //   icon: "mdi-package-variant-closed",
    //   type: "sourcing",
    // },
    // {
    //   text: "track shipments with ShipEngine",
    //   to: "sourcing-shipEngine-report",
    //   desc: "View & update tracking numbers with the ShipEngine integration",
    //   icon: "mdi-shipping-pallet",
    //   type: "sourcing",
    // },
    // {
    //   text: "deposits",
    //   to: "sourcing-deposits-report",
    //   desc: "Payments made towards Vendor/Custom orders",
    //   icon: "mdi-cash",
    //   type: "sourcing",
    // },
    // {
    //   text: "work orders",
    //   to: "manufacturing-workOrders-report",
    //   desc: "Work orders at fulfillment location by selected date range",
    //   icon: "mdi-beaker",
    //   type: "manufacturing",
    // },
    {
      text: "inventory",
      to: "manufacturing-inventory-report",
      desc: "Assembled/Component inventory across selected state. Includes work & vendor order(s) to show what's being manufactured or incoming",
      icon: "mdi-sitemap",
      type: "manufacturing",
    },

    {
      text: "product lot management",
      to: "manufacturing-productLots-report",
      desc: "Search, filter & update product lots based on expiration date",
      icon: "mdi-tag-edit",
      type: "manufacturing",
    },
    {
      text: "work orders",
      to: "manufacturing-workOrderCogs-report",
      desc: "-",
      icon: "mdi-receipt-text-outline",
      type: "manufacturing",
    },
    {
      text: "labor allocation",
      to: "manufacturing-laborAllocation-report",
      desc: "-",
      icon: "mdi-account-details",
      type: "manufacturing",
    },
    {
      text: "SKU inventory activity",
      to: "manufacturing-inventoryActivity-report",
      desc: "Comprehensive view of all SKU inventory movements across all locations, brands, and products with detailed audit trail",
      icon: "mdi-history",
      type: "manufacturing",
    },
    {
      text: "SKU inventory activity II",
      to: "manufacturing-inventoryActivityII-report",
      desc: "Alternative SKU inventory activity report (grouped by SKU and filters)",
      icon: "mdi-history",
      type: "manufacturing",
    },
    // {
    //   text: "Labor - V2",
    //   to: "manufacturing-laborv2-report",
    //   desc: "",
    //   icon: "mdi-history",
    //   type: "manufacturing",
    // },
    {
      text: "Component Inventory",
      to: "manufacturing-componentinventory-report",
      desc: "",
      icon: "mdi-puzzle",
      type: "manufacturing",
    },
    {
      text: "reconciles",
      to: "admin-reconciles-report",
      desc: "View inventory reconcile receipts across all locations (with notes + reasons)",
      icon: "mdi-receipt-text",
      type: "manufacturing",
    },
    {
      text: "leaderboard",
      to: "sales-leaderboard-report",
      desc: "Compare active sales reps across metrics like orders/tasks/closes/collections/store events/trainings",
      icon: "mdi-crown",
      type: "sales",
      salesRepDashboard: true,
    },
    {
      text: "rep score",
      to: "sales-score-report",
      desc: "Score card of sales rep (tasks/accounts/orders/store events/trainings)",
      icon: "mdi-trophy-award",
      type: "sales",
    },
    // {
    //   text: "accounts",
    //   to: "sales-accounts-report",
    //   desc: "All accounts within selected state",
    //   icon: "mdi-folder-account",
    //   type: "sales",
    // },
    {
      text: "account metrics",
      to: "sales-accountMetrics-report",
      desc: "Growth of brand within account, product trends, total promotion",
      icon: "mdi-chart-areaspline",
      type: "sales",
    },
    {
      text: "account map",
      to: "sales-map-report",
      desc: "Visualize a map of account(s). Filter by status/managing staff...",
      icon: "mdi-map",
      type: "sales",
    },
    {
      text: "account pricing",
      to: "sales-accountPricing-report",
      desc: "View a list of accounts with special pricing",
      icon: "mdi-card-account-details-star",
      type: "sales",
    },
    {
      text: "closes",
      to: "sales-closes-report",
      desc: "View all accounts closed within a selected date range",
      icon: "mdi-party-popper",
      type: "sales",
    },
    {
      text: "account onboardings",
      to: "sales-onboardings-report",
      desc: "Pending/Complete onboarding(s), calculates AVG completion time",
      icon: "mdi-timeline-check",
      type: "sales",
    },
    // {
    //   text: "action lists",
    //   to: "sales-actionLists-report",
    //   desc: "View results of assigned task lists by selected date range",
    //   icon: "mdi-list-status",
    //   type: "sales",
    // },
    {
      text: "tasks",
      to: "sales-tasks-report",
      desc: "View pending/complete tasks for active sales reps based on a selected date range",
      icon: "mdi-file-tree",
      type: "sales",
    },
    {
      text: "MTD sales",
      to: "sales-brandmtd-report",
      desc: "Month-to-date sales for selected state(s), includes monthly goal & percentage of goal completed",
      icon: "mdi-trending-up",
      type: "sales",
    },
    {
      text: "orders",
      to: "sales-orders-report",
      desc: "Orders created/shipped within selected date range. Orders are assigned to who is currently managing account",
      icon: "mdi-clipboard-list",
      type: "sales",
      salesRepDashboard: true,
    },
    {
      text: "orders (by account)",
      to: "sales-ordersByAccount-report",
      desc: "Show all orders related to selected account(s), with month/month growth",
      icon: "mdi-account-search",
      type: "sales",
    },
    // {
    // 	text: "sample orders",
    // 	to: "sales-sampleOrders-report",
    // 	desc: "View a list of delivered sample orders, lost revenue from samples",
    // 	icon: "mdi-clipboard-list",
    // 	type: "sales",
    // 	salesRepDashboard: false,
    // },
    // {
    //   text: "trace orders",
    //   to: "sales-traceOrders-report",
    //   desc: "View sales orders based on date of status (Orders in 'submitted' on MM/DD/YYYY)",
    //   icon: "mdi-clipboard-text-clock",
    //   type: "sales",
    // },
    // {
    //   text: "post discount sales",
    //   to: "sales-postDiscount-report",
    //   desc: "View the adjusted revenue of order(s) after filtering out discounts applied",
    //   icon: "mdi-clipboard-list",
    //   type: "sales",
    // },
    // {
    //   text: "product trends",
    //   to: "sales-products-report",
    //   desc: "Month over Month trends by selected state. Includes delivery counties",
    //   icon: "mdi-swap-vertical-bold",
    //   type: "sales",
    // },
    // {
    //   text: "top products",
    //   to: "sales-topProducts-report",
    //   desc: "",
    //   icon: "mdi-swap-vertical-bold",
    //   type: "sales",
    // },
    {
      text: "sales by product categories",
      to: "sales-productCategories-report",
      desc: "-",
      icon: "mdi-sitemap",
      type: "sales",
    },
    // {
    // 	text: "sales by product",
    // 	to: "sales-products-report",
    // 	desc: "-",
    // 	icon: "mdi-sitemap",
    // 	type: "sales",
    // },
    {
      text: "1st Purchase",
      to: "sales-firstPurchase-report",
      desc: "View first purchase date of each category for accounts in the selected state",
      icon: "mdi-order-numeric-ascending",
      type: "sales",
    },
    {
      text: "delivery/logistics orders",
      to: "sales-deliveryLogistics-report",
      desc: "View orders by selected delivery company. Calculates AVG turnaround time & delivery counties",
      icon: "mdi-truck",
      type: "sales",
    },
    // {
    //   text: "delivery COGS",
    //   to: "support-deliveryCogs-report",
    //   desc: "Calculate delivery cogs of delivered orders based on a commission percentage",
    //   icon: "mdi-calculator",
    //   type: "sales",
    // },
    {
      text: "accounts receivable",
      to: "sales-ar-report",
      desc: "Aging report for account(s) with orders with an open balance. Sorted by Within Terms/30/60/90/120+ days past due",
      icon: "mdi-hand-coin",
      type: "sales",
      salesRepDashboard: true,
    },
    {
      text: "payments",
      to: "sales-payments-report",
      desc: "Payments submitted within selected date range. Will calculate rep bonus based on payment received before order is delinquent",
      icon: "mdi-cash",
      type: "sales",
    },
    {
      text: "bonus",
      to: "sales-bonus-report",
      desc: "Calculate bonuses payable to sales representatives based on payments received and promotional value given within a selected date range.",
      icon: "mdi-account-cash",
      type: "sales",
    },
    {
      text: "credits",
      to: "sales-credits-report",
      desc: "View credits within a customizable date range",
      icon: "mdi-seal",
      type: "sales",
    },
    {
      text: "credits vs. sales",
      to: "sales-creditsVsSales-report",
      desc: "View credits vs. sales within a customizable date range",
      icon: "mdi-chart-areaspline",
      type: "sales",
    },
    {
      text: "store events",
      to: "support-storeEvents-report",
      desc: "View store events within selected date range. Leaderboard of top events/trending products",
      icon: "mdi-calendar-multiple",
      type: "retail success",
    },
    {
      text: "trainings",
      to: "support-trainings-report",
      desc: "Trainings within selected date range. Includes a leaderboard of individualized rep metrics & metrics of trending training type(s)",
      icon: "mdi-school",
      type: "retail success",
    },
    {
      text: "support tickets",
      to: "support-supportTickets-report",
      desc: "Pending/Complete support tickets, includes a chart of trending product categories being exchanged within ticket(s)",
      icon: "mdi-briefcase",
      type: "retail success",
    },
  ],
  locationTypes: [
    {
      text: "Main Hub",
      desc: "A warehouse where product(s) are stored. No manufacturing/work orders.",
      value: "mainHub",
    },
    {
      text: "Fulfillment",
      desc: "All of the features of a Main Hub, but raw materials/work orders are available.",
      value: "fulfillment",
    },
  ],
  contactTitles: [
    {
      text: "Owner",
      value: "owner",
    },
    {
      text: "Marketing",
      value: "marketing",
    },
    { text: "Purchasing Manager", value: "purchasing manager" },
    { text: "Store Manager", value: "store manager" },
    { text: "General Manager", value: "general manager" },
    { text: "Inventory Manager", value: "inventory manager" },
    { text: "License Holder", value: "license holder" },
    { text: "Accounting", value: "accounting" },
    { text: "Buyer", value: "buyer" },
    { text: "Budtender", value: "budtender" },
    { text: "Sales", value: "sales" },
    { text: "Events", value: "events" },
    { text: "Brand Ambassador", value: "brand ambassador" },
    { text: "Scheduling Coordinator", value: "scheduling coordinator" },
    { text: "Customer", value: "customer" },
    { text: "Other", value: "other" },
  ],
  contactPreferences: [
    { text: "Call", value: "call" },
    { text: "Text (SMS)", value: "text" },
    { text: "Email", value: "email" },
  ],
  integrations: [
    {
      name: "Slack",
      purpose: "Direct/Group messaging",
      value: "slack",
      type: "communication",
      requiresConfig: true,
      externalID: false,
      hasAPIEndpoints: false,
    },
    {
      name: "Dialpad",
      purpose: "Calling/Texting",
      value: "dialpad",
      type: "communication",
      requiresConfig: false,
      externalID: false,
      hasAPIEndpoints: false,
    },
    {
      name: "SendGrid",
      purpose: "Email templates",
      value: "sendgrid",
      type: "communication",
      requiresConfig: true,
      externalID: false,
      hasAPIEndpoints: false,
    },
    {
      name: "LeafLink",
      text: "LeafLink",
      purpose: "Cannabis sales ordering platform",
      value: "leaflink",
      type: "sales",
      requiresConfig: true,
      externalID: true,
      hasAPIEndpoints: true,
    },
    {
      name: "Distru",
      text: "Distru",
      purpose: "Cannabis ERP platform",
      value: "distru",
      type: "sales",
      requiresConfig: false,
      externalID: true,
      hasAPIEndpoints: true,
    },
    {
      name: "Apex Trading",
      text: "Apex Trading",
      purpose: "Cannabis MRP / CRM & sales ordering platform",
      value: "apextrading",
      type: "sales",
      requiresConfig: true,
      externalID: false,
      hasAPIEndpoints: true,
    },
    {
      name: "Canix",
      text: "Canix",
      purpose: "Cannabis ERP",
      value: "canix",
      type: "sales",
      requiresConfig: false,
      externalID: false,
      hasAPIEndpoints: true,
    },
    // {
    //   name: "ShipEngine",
    //   purpose:
    //     "Automate tracking number updates from multiple couriers (UPS/DHL/FedEx...)",
    //   value: "shipengine",
    //   type: "shipping",
    //   requiresConfig: true,
    //   externalID: false,
    //   hasAPIEndpoints: false,
    // },
    {
      name: "BioTrack",
      purpose: "State compliance software for manifesting orders",
      value: "biotrack",
      type: "compliance",
      requiresConfig: false,
      externalID: false,
      hasAPIEndpoints: false,
    },
    {
      name: "Metrc",
      purpose: "State compliance software for manifesting orders",
      value: "metrc",
      type: "compliance",
      requiresConfig: true,
      externalID: false,
      hasAPIEndpoints: false,
    },
    // {
    //   name: "VIP Club",
    //   purpose: "Gather industry contacts through a lead generation form",
    //   value: "vipClub",
    //   requiresConfig: false,
    //   externalID: false,
    //   hasAPIEndpoints: false,
    // },
    {
      name: "Elite Extra",
      purpose: "Order routing / driver dispatching",
      value: "eliteExtra",
      type: "delivery",
      requiresConfig: false,
      externalID: false,
      hasAPIEndpoints: false,
    },
    {
      name: "ShipStation",
      text: "ShipStation",
      purpose: "Automated order fulfillment & shipping",
      value: "shipstation",
      type: "shipping",
      requiresConfig: true,
      externalID: false,
      hasAPIEndpoints: false,
    },
    {
      name: "Zoho",
      purpose: "CRM for managing accounts/contacts",
      value: "zoho",
      type: "crm",
      requiresConfig: true,
      externalID: false,
      hasAPIEndpoints: false,
    },
    {
      name: "Nabis",
      purpose: "Cannabis delivery platform",
      value: "nabis",
      type: "delivery",
      requiresConfig: true,
      externalID: false,
      hasAPIEndpoints: false,
    },
    {
      name: "Flourish",
      text: "Flourish",
      purpose: "Cannabis Seed-to-Sale ERP",
      value: "flourish",
      type: "sales",
      requiresConfig: false,
      externalID: false,
      hasAPIEndpoints: true,
    },
    {
      name: "Hoodie Analytics",
      text: "Hoodie Analytics",
      purpose: "-",
      value: "hoodie",
      type: "analytics",
      requiresConfig: true,
      externalID: false,
      hasAPIEndpoints: true,
    },
    {
      name: "EZOffice Inventory",
      text: "EZOffice Inventory",
      purpose: "Warehouse Management (WMS)",
      value: "ezo",
      type: "wms",
      requiresConfig: true,
      externalID: false,
      hasAPIEndpoints: true,
    },
    {
      name: "Trees N Clouds",
      text: "Trees N Clouds",
      purpose: "-",
      value: "treesnclouds",
      type: "analytics",
      requiresConfig: true,
      externalID: false,
      hasAPIEndpoints: true,
    },
    {
      name: "Quickbooks",
      text: "Quickbooks",
      purpose: "-",
      value: "quickbooks",
      type: "accounting",
      requiresConfig: false,
      externalID: false,
      hasAPIEndpoints: true,
    },
    {
      name: "Sage Intacct",
      text: "Sage Intacct",
      purpose: "-",
      value: "intacct",
      type: "accounting",
      requiresConfig: false,
      externalID: false,
      hasAPIEndpoints: true,
    },
    {
      name: "Method",
      text: "Method",
      purpose: "-",
      value: "method",
      type: "Quickbooks integrated CRM",
      requiresConfig: true,
    },
    {
      name: "Monday",
      text: "Monday",
      purpose: "-",
      value: "monday",
      type: "CRM",
      requiresConfig: true,
    },
  ],
  countryCodes: [
    {
      name: "antartica",
      abbreviation: "dt",
      countryCode: "-999",
    },
    {
      name: "united states",
      abbreviation: "us",
      countryCode: "1",
    },
  ],
  fileUploadTypes: [
    { text: "Link to a URL (larger files)", value: "url" },
    { text: "Upload a file", value: "upload" },
  ],
  notification: {
    dialog: false,
    record: null,
    loading: false,
    users: [],
  },
  actionList: {
    dialog: false,
    record: null,
    loading: false,
    contacts: [],
  },
  alert: {
    dialog: false,
    record: null,
    collection: "",
    loading: false,
  },
  email: {
    dialog: false,
    record: null,
    loading: false,
    users: [],
  },
  rightDrawer: {
    active: false,
  },
  creditRequests: [
    {
      text: "Approved",
      value: "approved",
      desc: "A credit will be added to the account.",
    },
    {
      text: "Approved - With Exception",
      value: "approvedWithException",
      desc: "",
    },
    {
      text: "Waiting for Approval",
      value: "waitingForApproval",
      desc: "The credit is waiting for approval and can be approved/rejected at a later date. All data entered will be saved.",
    },
    {
      text: "Missing Report",
      value: "missingReport",
      desc: "The report submitted is missing information or the incorrect report. Will revert this submission back to a 'New' state",
    },
    {
      text: "Rejected",
      value: "rejected",
      desc: "This report is rejected & a credit will not be added to the account.",
    },
  ],
};

const actions = {
  async _notification({ commit }, payload) {
    let users = [];

    commit("setNotificationUsers", users);
    commit("setNotificationDialog", payload.dialog);
    if (payload.dialog) {
      commit("setNotificationUsersLoading", true);
      const usersRef = collection(firestore, "users");
      const q = query(
        usersRef,
        where("active", "==", true),
        where("accountType", ">=", 2),
      );
      const response = await getDocs(q);

      if (!response.empty) {
        users = response.docs
          .map((user) => {
            return {
              text: `${user.data().name.first} ${user.data().name.last}`,
              name: user.data().name,
              department: user.data().department ? user.data().department : "-",
              email: user.data().email,
              value: user.id,
            };
          })
          .sort((a, b) => (a.name.first > b.name.first ? 1 : -1));
        commit("setNotificationUsers", users);
        commit("setNotificationUsersLoading", false);
      }

      commit("setNotificationRecord", {
        notes: "",
        assignedTo: [],
        related: payload.related,
      });
    }
  },
  async _actionList({ commit }, payload) {
    commit("setActionListRecord", null);
    commit("setActionListDialog", payload.dialog);

    if (payload.dialog) {
      commit("setActionListRecord", payload.related);
    }
  },
  async _recordAlert({ commit }, payload) {
    commit("setAlertRecord", null);
    commit("setAlertDialog", payload.dialog);

    if (payload.dialog) {
      commit("setAlertRecord", payload.related);
    }
  },
  async _email({ commit }, payload) {
    let users = [],
      cc = [],
      contacts = [],
      templates = [];

    commit("setEmailUsers", users);
    commit("setEmailDialog", payload.dialog);
    if (payload.dialog) {
      // Contacts
      const relatedID = payload.related.id;
      const contactsRef = collection(firestore, "contacts");
      const contactsQ = query(
        contactsRef,
        where("active", "==", true),
        where("related.id", "==", relatedID),
        where("title", "!=", "customer"),
      );
      const contactsResponse = await getDocs(contactsQ);
      if (!contactsResponse.empty) {
        contacts = contactsResponse.docs
          .map((contact) => {
            return {
              id: contact.id,
              text: `${contact.data().name.first} ${contact.data().name.last}`,
              title: contact.data().title,
              name: contact.data().name,
              email: contact.data().email,
              value: contact.data().email,
            };
          })
          .sort((a, b) => (a.name.first > b.name.first ? 1 : -1));
      }

      // Users
      commit("setEmailUsersLoading", true);
      const usersRef = collection(firestore, "users");
      const q = query(
        usersRef,
        where("active", "==", true),
        where(documentId(), "!=", auth.currentUser.uid),
      );
      const response = await getDocs(q);

      if (!response.empty) {
        users = response.docs
          .map((user) => {
            return {
              text: `${user.data().name.first} ${user.data().name.last}`,
              name: user.data().name,
              department: user.data().department ? user.data().department : "-",
              id: user.id,
              email: user.data().email,
              value: user.data().email,
              reportsTo: user.data().reportsTo,
            };
          })
          .sort((a, b) => (a.name.first > b.name.first ? 1 : -1));
        commit("setEmailUsers", users);
        commit("setEmailUsersLoading", false);

        if (payload.related.staff) {
          payload.related.staff.forEach((userID) => {
            const selectedUser = users.find((option) => option.id === userID);
            if (selectedUser) {
              cc.push(selectedUser.email);
            }
          });
        }
        console.log(payload);

        const templatesRef = collection(firestore, "emailTemplates");
        const templatesQ = query(
          templatesRef,
          where("active", "==", true),
          where("phase", "==", payload.related.phase),
        );
        const templatesResponse = await getDocs(templatesQ);
        if (!templatesResponse.empty) {
          templates = templatesResponse.docs
            .map((template) => {
              return {
                created: moment(
                  template.data().created.seconds * 1000,
                ).toDate(),
                updated: moment(
                  template.data().updated.seconds * 1000,
                ).toDate(),
                subject: template.data().subject,
                body: template.data().body,
                value: template.id,
              };
            })
            .sort((a, b) => (a.subject > b.subject ? 1 : -1));
        }
      }

      commit("setEmailRecord", {
        subject: "",
        body: "",
        files: [],
        to: [],
        cc,
        bcc: [],
        templates,
        contacts,
        related: payload.related,
        staff: payload.related.staff || [],
        phase: payload.related.phase,
        template: null,
        attachments: [],
      });
    }
  },
  _rightDrawer({ commit }, payload) {
    commit("setRightDrawer", payload);
  },
};

const mutations = {
  // Notification
  setNotificationDialog(state, payload) {
    state.notification.dialog = payload;
    this.rightDrawer;
  },
  setNotificationRecord(state, payload) {
    state.notification.record = payload;
  },
  setNotificationUsers(state, payload) {
    state.notification.users = payload;
  },
  setNotificationUsersLoading(state, payload) {
    state.notification.loading = payload;
  },
  // Action List
  setActionListDialog(state, payload) {
    state.actionList.dialog = payload;
  },
  setActionListRecord(state, payload) {
    state.actionList.record = payload;
  },
  setNotificationContacts(state, payload) {
    state.notification.users = payload;
  },
  setActionListLoading(state, payload) {
    state.actionList.loading = payload;
  },
  // Alerts
  setAlertDialog(state, payload) {
    state.alert.dialog = payload;
  },
  setAlertRecord(state, payload) {
    state.alert.record = payload;
  },
  // Email
  setEmailDialog(state, payload) {
    state.email.dialog = payload;
  },
  setEmailRecord(state, payload) {
    state.email.record = payload;
  },
  setEmailUsers(state, payload) {
    state.email.users = payload;
  },
  setEmailContacts(state, payload) {
    state.email.contacts = payload;
  },
  setEmailUsersLoading(state, payload) {
    state.email.loading = payload;
  },
  setRightDrawer(state, payload) {
    state.rightDrawer = payload;
  },
};

const getters = {
  getAppName(state) {
    return state.appName;
  },
  getPhases(state) {
    return state.phases;
  },
  getPhaseViews(state) {
    return state.phaseViews;
  },
  getReports(state) {
    return state.reports;
  },
  getLocationTypes(state) {
    return state.locationTypes;
  },
  getContactTitles(state) {
    return state.contactTitles;
  },
  getContactPreferences(state) {
    return state.contactPreferences;
  },
  getIntegrations(state) {
    return state.integrations;
  },
  getCountryCodes(state) {
    return state.countryCodes;
  },
  getFileUploadTypes(state) {
    return state.fileUploadTypes;
  },
  // Notifications
  getNotificationDialog(state) {
    return state.notification.dialog;
  },
  getNotificationRecord(state) {
    return state.notification.record;
  },
  getNotificationUsers(state) {
    return state.notification.users;
  },
  getNotificationUsersLoading(state) {
    return state.notification.loading;
  },
  // Action List
  getActionListDialog(state) {
    return state.actionList.dialog;
  },
  getActionListRecord(state) {
    return state.actionList.record;
  },
  // Alert
  getAlertDialog(state) {
    return state.alert.dialog;
  },
  getAlertRecord(state) {
    return state.alert.record;
  },
  // Emails
  getEmailDialog(state) {
    return state.email.dialog;
  },
  getEmailRecord(state) {
    return state.email.record;
  },
  getEmailUsers(state) {
    return state.email.users;
  },
  getEmailUsersLoading(state) {
    return state.email.loading;
  },
  getRightDrawer(state) {
    return state.rightDrawer;
  },
  // Credit Requests
  getCreditRequestAction(state) {
    return state.creditRequests;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
